import React from 'react';
import { useTheme } from '@24i/nxg-sdk-higgs';
import { View, Text } from '@24i/nxg-sdk-quarks';
import PackshotGrid from '@24i/nxg-sdk-gluons/src/components/containers/PackshotGrid';
import Loader from '@24i/nxg-sdk-gluons/src/components/ui/Loader';
import { getTelegramWebApp, isWebMobile } from '@24i/nxg-sdk-higgs/src/utils';
import { withWebHeader } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader';
import { WithWebHeaderProps } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader/types';

import getSeeAllScreenStyles from '../styles/index.web';
import { SeeAllScreenWebProps, SEE_ALL_TEST_IDS } from '../types';

const SeeAllScreen = ({
    assets,
    assetsLabel,
    styles: getStyles = getSeeAllScreenStyles,
    isLoading,
    gridContainerRef,
    displayType,
    handlePackshotPress,
}: SeeAllScreenWebProps & WithWebHeaderProps) => {
    const { theme } = useTheme();
    const styles = getStyles(theme);

    return (
        <View style={styles.holder} ref={gridContainerRef} testID={SEE_ALL_TEST_IDS.CONTAINER}>
            {!getTelegramWebApp() && (
                <View style={styles.pickerHolder}>
                    <Text style={styles.sectionTitle} testID={SEE_ALL_TEST_IDS.TITLE}>
                        {assetsLabel}
                    </Text>
                </View>
            )}
            {/* @ts-ignore */}
            <PackshotGrid
                items={assets}
                onItemPress={handlePackshotPress}
                displayType={displayType}
            />
            {isLoading && <Loader />}
        </View>
    );
};

// Adding display name for better debugging
SeeAllScreen.displayName = 'SeeAllScreen';

// IMPORTANT: We need different configurations:
// 1. For Telegram: Use 'sticky' variant to properly initialize back button without visual changes
// 2. For web mobile (non-Telegram): Use 'sticky' variant to ensure the header title is shown
// 3. For desktop web: Use normal header
export default (props: SeeAllScreenWebProps & WithWebHeaderProps) => {
    // Get environment information
    const isTelegram = !!getTelegramWebApp();
    const isMobile = isWebMobile();

    // Create a set of enhanced props to handle all cases
    const enhancedProps = {
        ...props,
        // Always use sticky for both Telegram and mobile web to ensure proper header display
        variant: isTelegram || isMobile ? 'sticky' : undefined,
        // This flags that we're on mobile web
        isMobileView: isMobile,
        // Explicitly set webHeaderTitle to ensure it's displayed in the header
        webHeaderTitle: props.assetsLabel,
        // Base layout settings
        fullWidth: true,
        hasMargin: false,
        noVerticalMargin: true,
        // Always force header visibility to ensure title is shown
        forceShowHeader: true,
    };

    // Pass the enhanced props to withWebHeader
    return withWebHeader(SeeAllScreen)(enhancedProps);
};
